import { FC, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { EditorAddOrEdit } from "../EditorAddOrEdit/EditorAddOrEdit";
import { useParams } from "react-router-dom";
import EmailTemplateBuilderServiceQuery from "../../../services/query/emailTemplateBuilder/emailTemplateBuilderService.services";
import Swal from "sweetalert2";
import { ETBES } from "../emailTemplateBuilder.classes";
interface Params {
  sectionId: string;
}

export const EditSection: FC = () => {
  const { t } = useTranslation();
  const [datas, setDatas] = useState<any>();
  const Params = useParams<Params>();

  useEffect(() => {
    if (!Params.sectionId) {
      return;
    }
    EmailTemplateBuilderServiceQuery.GetSingleSectionData(
      Params.sectionId
    ).then((res) => {
      if (!res) {
        Swal.fire(t("general.notFound"), " ", "error");
        return;
      }
      setDatas(res.data);
    });
  }, []);
  return (
    <>
      {datas ? (
        <Box className={ETBES.page}>
          <EditorAddOrEdit editDatas={datas}></EditorAddOrEdit>
        </Box>
      ) : (
        <div className={ETBES.notFoundState}>SectionId bulunamadı</div>
      )}
    </>
  );
};
